import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "clock-colorful--circle--light",
  "use": "clock-colorful--circle--light-usage",
  "viewBox": "0 0 16.72 17",
  "content": "<symbol viewBox=\"0 0 16.72 17\" id=\"clock-colorful--circle--light\"><defs><linearGradient id=\"clock-colorful--circle--light_a\" x1=\"-47.73\" y1=\"-42.63\" x2=\"59.71\" y2=\"55.3\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0\" stop-color=\"#f78a79\" /><stop offset=\"1\" stop-color=\"#f06767\" /></linearGradient></defs><title>time</title><path d=\"M10.49 9.5H7.83V6.16H8.9v2.27h1.59zM8.37 17a8.43 8.43 0 0 0 8.35-8.5A8.43 8.43 0 0 0 8.37 0 8.45 8.45 0 0 0 0 8.5 8.45 8.45 0 0 0 8.37 17m0-15.94a7.37 7.37 0 0 1 7.29 7.44 7.37 7.37 0 0 1-7.29 7.44A7.38 7.38 0 0 1 1.06 8.5a7.38 7.38 0 0 1 7.31-7.44\" fill-rule=\"evenodd\" fill=\"url(#clock-colorful--circle--light_a)\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/clock-colorful--circle--light.svg
// module id = 197
// module chunks = 0